import { SupabankLogo } from "@/components/brand/SupabankLogo";
import { LandingFooter } from "@/components/public/LandingFooter";
import { Display, Text } from "@/components/ui/typography";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

const NotFound = () => {
  const { t } = useTranslation("common");
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center bg-background px-4">
        <div className="text-center max-w-md">
          <div className="flex justify-center mb-8">
            <SupabankLogo variant="full" size="lg" />
          </div>
          <Display variant="lg" className="mb-4">{t("errors.404.title")}</Display>
          <Text variant="lg" color="muted" className="mb-4">{t("errors.404.message")}</Text>
          <Link to="/" className="text-primary hover:text-primary/80 underline underline-offset-4">
            {t("errors.404.returnHome")}
          </Link>
        </div>
      </div>
      <LandingFooter />
    </div>
  );
};

export default NotFound;
